import { React, useState, useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { Grid, Typography, TextField, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from 'react-i18next';
import CopyButton from '../common/CopyButton';
import {
  CalculatorContainer,
  CalculatorTitle,
  DateContainer,
  ResultTypography,
  datePickerStyles,
  textFieldStyles
} from '../../shared/styles';

function DayCalculator() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(dayjs());
  const [days, setDays] = useState(0);
  const [resultDate, setResultDate] = useState(dayjs());

  useEffect(() => {
    setResultDate(startDate.add(days, 'day'));
  }, [startDate, days]);

  const resultText = resultDate.format('YYYY-MM-DD');

  return (
    <CalculatorContainer>
      <CalculatorTitle variant={isMobile ? "h5" : "h4"}>
        {t('dayCalc.title')}
      </CalculatorTitle>
      <Grid
        container
        spacing={isMobile ? 2 : 3}
        justifyContent="center"
        sx={{ flexGrow: 1 }}
      >
        <Grid item xs={12} sm={6}>
          <DateContainer>
            <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
              {t('dayCalc.baseDate')}
            </Typography>
            <DatePicker
              onChange={setStartDate}
              value={startDate}
              sx={datePickerStyles}
            />
          </DateContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateContainer>
            <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
              {t('dayCalc.daysToAddSub')}
            </Typography>
            <TextField
              type="number"
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
              fullWidth
              sx={textFieldStyles}
            />
          </DateContainer>
        </Grid>
      </Grid>
      <ResultTypography
        variant={isMobile ? "h4" : "h3"}
        sx={{ mt: 'auto', mb: 2 }}
      >
        {resultText}
        <CopyButton text={resultText} />
      </ResultTypography>
    </CalculatorContainer>
  );
}

export default DayCalculator; 